// extracted by mini-css-extract-plugin
export default {"label":"style_label__B53xQ","button":"style_button__SJuAd"};